/*
 * Copyright (c) 2024. World Wide Generation Ltd
 */

import { StatusBadge, type StatusBadgeConfig } from '@g17eco/molecules/badge/StatusBadge';
import { InsightStatus } from '@g17eco/types/insights-synthesis';

interface InsightStatusBadgeProps {
  status: InsightStatus;
}

const statusConfig: Record<InsightStatus, StatusBadgeConfig> = {
  [InsightStatus.PendingApproval]: { color: 'warning', icon: 'fa-hourglass-half', label: 'Pending Approval' },
  [InsightStatus.Approved]: { color: 'success', icon: 'fa-check', label: 'Approved' },
  [InsightStatus.Rejected]: { color: 'danger', icon: 'fa-times', label: 'Rejected' },
  [InsightStatus.Pruned]: { color: 'secondary', icon: 'fa-trash', label: 'Pruned' },
};

export const InsightStatusBadge = ({ status }: InsightStatusBadgeProps) => {
  const config = statusConfig[status];

  return <StatusBadge config={config} minWidth={130} />;
};
